module.exports = __webpack_public_path__ + "img/assassin.27e4c7b0.svg";